export default "__VITE_ASSET__DZPkwRuO__"